var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "577A1F3A-4C76-48DD-AF18-236883A8893A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 14.9318236 0 14.9318236 14.932 0 14.932"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 17.3465887 14.932 17.3465887 14.932 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-Web",
    transform: "translate(-181.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timer",
    transform: "translate(181.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 2.414589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46582362,13.1682391 C4.32191977,13.1682391 1.76358455,10.6107857 1.76358455,7.466 C1.76358455,4.32209615 4.32191977,1.76376093 7.46582362,1.76376093 C8.91563511,1.76376093 10.2375739,2.31229057 11.2446814,3.20739924 L11.7244244,3.68714222 C12.619533,4.6942497 13.1680627,6.01618852 13.1680627,7.466 C13.1680627,10.6107857 10.6097275,13.1682391 7.46582362,13.1682391 M13.2183299,2.7126643 L14.552615,1.37749728 L13.4026429,0.227525159 L12.0463107,1.58297543 C10.7799304,0.595269313 9.19254557,0 7.46582362,0 C3.34920562,0 -0.000176376093,3.349382 -0.000176376093,7.466 C-0.000176376093,11.582618 3.34920562,14.932 7.46582362,14.932 C11.5824416,14.932 14.9318236,11.582618 14.9318236,7.466 C14.9318236,5.66167257 14.2880509,4.00461918 13.2183299,2.7126643",
    id: "Fill-1",
    fill: "#020303",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#020303",
    mask: "url(#mask-4)",
    points: "6.65202433 9.88058871 8.27909379 9.88058871 8.27909379 5.70400283 6.65202433 5.70400283"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#020303",
    mask: "url(#mask-4)",
    points: "5.03553744 1.62706945 9.89646256 1.62706945 9.89646256 0 5.03553744 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.f6408500e91e755643ab7588935cb212.svg";
export { ForwardRef as ReactComponent };